document.addEventListener("DOMContentLoaded", () => {
  const modal = document.querySelector("[data-age-restriction-modal]");
  const rejectedText = modal.querySelector("[data-age-rejected-text]");

  const hasAgreed = localStorage.getItem("ageAgreement");

  if (!hasAgreed) {
    modal.style.display = "block";
  }

  modal.addEventListener("click", (e) => {
    if (e.target.tagName === "BUTTON") {
      if (e.target.value === "agree") {
        modal.style.display = "none";
        localStorage.setItem("ageAgreement", "yes");
      } else {
        rejectedText.style.display = "block";
      }
    } else {
      e.preventDefault();
    }
  });
});
